import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'components/core/Tooltip';

import './Badge.scss';

export function Badge({
	className,
	badgeText,
	badgeIcon,
	badgeColor = 'blue',
	tooltipText = '',
	iconSize = 16,
	textSize = null,
}) {
	return (
		<div className={classnames(className, 'badge', `badge-${badgeColor}`)}>
			{tooltipText && (
				<Tooltip
					content={tooltipText}
					placement="top"
				>
					<div className="badge-icon">{badgeIcon}</div>
				</Tooltip>
			)}
			{badgeIcon && (
				<div
					className={classnames('badge-icon', {
						'icon-size': iconSize,
					})}
				>
					{badgeIcon}
				</div>
			)}
			{badgeText && (
				<div className={classnames('badge-text', { [`badge-text-${textSize}`]: textSize })}>
					{badgeText}
				</div>
			)}
		</div>
	);
}

Badge.propTypes = {
	className: PropTypes.string,
	badgeText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	badgeIcon: PropTypes.element,
	badgeColor: PropTypes.string,
	tooltipText: PropTypes.string,
	iconSize: PropTypes.number,
	textSize: PropTypes.string,
};

export default Badge;
